import React, { useState } from 'react';
import { FlatList, TouchableOpacity, View } from 'react-native';

import tw from '@/styles/tailwind';
import Text from '@/components/Text';
import Icon from '@/components/IcomoonIcon';
import api from '@/utils/api';
import { Image } from 'expo-image';
import { useQuery } from '@tanstack/react-query';

import ReportsScreen from './ReportsScreen';

// Fila de desarrollo (mismo patrón que CommunitiesScreen). Resalta el seleccionado.
function CommunityRow({ community, selected, onPress }: any) {
  return (
    <TouchableOpacity
      style={tw.style(
        `py-2 bg-white rounded-2xl border mx-4 mb-3`,
        selected ? `border-secondary` : `border-gray-200`,
      )}
      onPress={onPress}
    >
      <View style={tw`row justify-between items-center px-4 py-1`}>
        <View style={tw`flex-1 row items-center`}>
          {
            community.image_path &&
              <Image source={community.image_path} style={tw`h-10 w-10 rounded-xl mr-2`} />
          }
          <Text style={tw.style(`font-500`, selected ? `text-secondary` : `text-gray-700`)}>
            {community.name}
          </Text>
        </View>

        <Icon name="chevron-right" color={tw.color(selected ? 'secondary' : 'gray-400')} />
      </View>
    </TouchableOpacity>
  );
}

// Tab "Reportes" del panel Vinte (cross-comunidad): elige un desarrollo a la izquierda
// y muestra el índice de reportes (compartido) de esa comunidad a la derecha.
export default function VinteReportsScreen() {
  const [selectedCommunity, setSelectedCommunity] = useState<any>();

  const { isInitialLoading, data: communities } = useQuery({
    queryKey: ['vinte.communities'],
    queryFn: () => api.get(`/vinte/communities?`).then(response => response.data),
  });

  return (
    <View style={tw`row flex-1 h-full gap-x-4 bg-red-400 w-[600px]`}>
      {/* Columna izquierda: desarrollos */}
      <View style={tw`w-[300px] h-full px-2 py-3 bg-white rounded-xl`}>
        {
          isInitialLoading &&
            <Text style={tw`mt-10 text-center text-gray-400`}>Cargando...</Text>
        }
        {
          communities?.length === 0 &&
            <Text style={tw`mt-25 text-lg text-center text-gray-400`}>Sin desarrollos registrados</Text>
        }

        <FlatList
          data={communities}
          contentContainerStyle={tw`pt-2 pb-14`}
          renderItem={({ item }) => (
            <CommunityRow
              community={item}
              selected={selectedCommunity?.uuid === item.uuid}
              onPress={() => setSelectedCommunity(item)}
            />
          )}
          keyExtractor={item => item.uuid}
        />
      </View>

      {/* Columna derecha: índice de reportes de la comunidad elegida */}
      <View style={tw`flex-1 h-full bg-white rounded-xl overflow-hidden`}>
        {
          selectedCommunity
            ? <ReportsScreen communityId={selectedCommunity.uuid} detailRoute="Vinte.Reports.Detail" />
            : <Text style={tw`mt-25 text-lg text-center text-gray-400`}>Elige un desarrollo para ver sus reportes</Text>
        }
      </View>
    </View>
  );
}
